import * as React from 'react'
import isEmpty from 'lodash.isempty'
import { useContext } from 'react'
import { Icon } from '@blueprintjs/core'
import Help from '../../../../../components/Help'
import { GenericInput, GenericNumericInput } from '../../../../../components/Inputs'
import { templateStyles } from './templateStyles'
import WeightInput from '../../../../../printing/components/WeightInput'
import { ScaleContext } from '../../../../../printing/ScaleContext'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')

  const propsJS = props.toJS()
  const { helpText, ...childComponentProps } = propsJS

  // Calling useScaleStreamer directly here will be buggy. It will always read null, it won't change between dynamic/static, etc.
  // We already call useScaleStreamer at a higher level (ExpressListForm), and calling 2 instances of this hook somehow isn't safe.
  const { scaleName, scaleWeight, scaleConnected } = useContext(ScaleContext)

  const isExpressList = childComponentProps.requiredLabelIconName
  if (input.get('productField') === 'weight' && isExpressList) {
    // In Express List, we de-duplicate fields. We don't want to show 2 weight fields.
    // So we hide the regular weight field, and just show their "Couch Weight" (or whatever) builder template field.
    // Using WeightInput ensures they can still use their USB scale to measure weight.
    //
    // One caveat here - customers that map another field type to weight won't be able to use scales.
    // They should use the correct template field type if this comes up.

    // Avoid console errors b/c NumericInput passes all props into some DOM element
    const { requiredLabelIconName, hidden, ...weightInputProps } = childComponentProps

    return (
      <div>
        <WeightInput
          label={props.get('label')}
          onValueChange={(_valueAsNumber, valueAsString) => onFormPreviewChange(index, valueAsString)}
          min={0}
          minorStepSize={0.001}
          selectAllOnFocus
          buttonPosition="none"
          className="bp3-fill"
          formGroupClassName="weight-input"
          {...weightInputProps}
          scaleName={scaleName}
          scaleWeight={scaleWeight}
          scaleConnected={scaleConnected}
          // hide the required label once they fill it in. Express list wants this. Classic list... will just get it for free.
          required={propsJS.required && isEmpty(propsJS.value)}
          labelInfo={
            // If the field is required and missing, this helps show a required icon in the gutter.
            //
            // GenericNumericInput (and other similar template fields) automatically handle requiredLabelIconName
            // and create an error tooltip in the gutter of ExpressList, but WeightInput does not.
            // So we pass in labelInfo like other ExpressList inputs do (such as Listing strategy).
            propsJS.required && isEmpty(propsJS.value) && <Icon icon={childComponentProps.requiredLabelIconName} />
          }
          labelFor={props.get('label')}
        />
        {props.get('helpText') && (
          <Help>
            <div>{props.get('helpText')}</div>
          </Help>
        )}
      </div>
    )
  }

  return (
    <div>
      <GenericNumericInput
        className="bp3-fill"
        onChange={v => onFormPreviewChange(index, v)}
        title={props.get('label')}
        requiredLabelStyle={templateStyles.requiredLabel}
        // TODO: this could be incorrect in some circumstances, using a safe minorStepSize, but double-check
        minorStepSize={0.001}
        {...childComponentProps}
        // hide the required label once they fill it in. Express list wants this. Classic list... will just get it for free.
        required={propsJS.required && isEmpty(propsJS.value)}
      />
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')
  return (
    <div>
      <GenericInput
        title="Placeholder"
        value={inputProps.get('placeholder')}
        onChange={v => onChange('placeholder', v)}
      />
      <GenericNumericInput
        title="Minimum Value"
        value={inputProps.get('min')}
        onChange={v => onChange('min', v)}
        minorStepSize={0.001}
      />
      <GenericNumericInput
        title="Maximum Value"
        value={inputProps.get('max')}
        onChange={v => onChange('max', v)}
        minorStepSize={0.001}
      />
    </div>
  )
}
